/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-one-expression-per-line */
import { ReactElement, useState, useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import { TileRadioAccessible, TextInput, Modal, Button } from '@components';
import gridStyles from '@pages/forms/Grid.module.scss';
import { tile } from '@interfaces/interfaces';
import { getBasicInfo } from '@api/APIServices';
import { FormType } from '@constants/forms';
import { iNominationFormValues } from '@services/NominationService';
import emailNotif from '../../../../images/emailviewv2.png';
import mobileNotif from '../../../../images/mobileview.png';
import styles from './NominationStep3.module.scss';

function NominationStep3(): ReactElement {
  const currentDate = new Date();
  const expiryDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 7).toLocaleDateString('en-AU', { timeZone: 'Australia/Melbourne' });
  const [isOpenHelp, setOpenHelp] = useState(false);
  const [isNotifyHelp, setNotifyHelp] = useState(false);
  const [loading, setLoading] = useState(true);
  const { values, setFieldValue }: { values: iNominationFormValues; setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void } = useFormikContext<iNominationFormValues>();
  const closeNotifications = (modalName: string) => {
     if (modalName === 'savedForm') {
      setOpenHelp(false);
     } else {
     setNotifyHelp(false);
     }
  };

  const TILE_DATA: tile[] = [
    {
      body: 'Yes',
      value: 'true',
    },
    {
      body: 'No',
      value: 'false',
    },
  ];

  const TILE_DATA_NOTIFICATION_TYPE: tile[] = [
    {
      body: 'No thanks',
      value: 'none',
    },
    {
      body: 'To my mobile',
      value: 'mobile',
    },
    {
      body: 'To my email',
      value: 'email',
    },
    {
      body: 'To both',
      value: 'both',
    },
  ];
  const howDoaccessSavedForm = (): ReactElement => (
    <>
      <div>
        <div>Visit fines.vic.gov.au, and click the ‘Your Fines’ link in the top right.
        </div>
        <br />
        <div>Enter your fine’s Obligation or Infringement number (these details are printed on your fine). You may also be asked to enter some other details about yourself, your licence or your vehicle.</div>
        <br />
        <div>Once you’ve logged in, under ‘Started applications’ you will see your incomplete form listed. Click the ‘Resume’ button to access your form.</div>
        <br />
      </div>
    </>
  );
  const notificationInformation = (): ReactElement => (
    <div style={{ width: '100%' }}>
      <div className={styles.bitmapSection}>
        <span className={styles.bitmapTitle}>Email notification</span>
        <span className={styles.bitmapTitle}>Mobile notification</span>
        <div className={styles.bitmapImage}>
          <img className={styles.image} src={emailNotif} alt="email notification view" />
        </div>
        <div className={styles.bitmapImage}>
          <img className={styles.image} src={mobileNotif} alt="mobile notification view" />
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    const getTicketInfo = async (obligationNum: string): Promise<void> => {
      setLoading(true);
      getBasicInfo(obligationNum, FormType.NOMINATION).then((responseBody) => {
        if (responseBody) {
          setFieldValue('Status', responseBody.Status);
          setFieldValue('DebtorType', responseBody.DebtorType);
          if (responseBody.DebtorType === 'Individual') {
            setFieldValue('isDebtorTypeIndividual', true);
          }
        }
      });
      setLoading(false);
    };
    getTicketInfo(values.OBLIGATION_NUMBER);
  }, []);
  return (
    <div className={gridStyles.form}>
      <span className="vfH2">Save this form?</span>
      <div className={gridStyles.gridColFull}>
        <div className="subHeadingH3">If you select Yes, we will save the form as you fill it in, so you can close it and come back later.</div>
      </div>
      <div className={gridStyles.gridColFull}>
        <div className={styles.col}>
          <Field name="SaveYesNo" component={TileRadioAccessible} tileData={TILE_DATA} orientationRow />
        </div>
      </div>
      <p>
        Your form content will be saved securely until submitted. To access saved forms later, visit our website, click ‘Your Fines’ and log in using the fine’s obligation or infringement number.
      </p>
      <p>
        Remember, the fine will continue to progress until you submit your application and receive a submission number.
      </p>
      {isOpenHelp && <Modal close={() => closeNotifications('savedForm')} show title="How do I access my saved form later?" content={howDoaccessSavedForm()} />}
      {values.SaveYesNo === 'true' && (
        <>
          <span className="vfH2">Send reminders about incomplete forms?</span>
          <div>We can send you a reminder to come back and submit your form.</div>
          <Field name="SaveOptions" component={TileRadioAccessible} tileData={TILE_DATA_NOTIFICATION_TYPE} orientationRow />
          {(values.SaveOptions === 'email' || values.SaveOptions === 'both') && (
            <Field name="saveEmail" title="Email Address" component={TextInput} isMandatory />
          )}
          {(values.SaveOptions === 'mobile' || values.SaveOptions === 'both') && (
            <Field name="saveMobile" title="Mobile Number" component={TextInput} isMandatory />
          )}
          <Button className={styles.modalLink} onClick={() => setNotifyHelp(true)} size="small">
            What will my notifications look like?
          </Button>
          {isNotifyHelp && <Modal close={() => closeNotifications('myNotify')} show title="What will my notifications look like?" content={notificationInformation()} />}
        </>
      )}
    </div>
  );
}

export default NominationStep3;
